import * as THREE from 'three';

/**
 * Converts azimuth/elevation (degrees) into a unit direction vector.
 * Shared by LightingSystem and EnvironmentSystem's sky so the visible sky
 * dome's sun position always matches the actual shadow-casting light
 * direction — two independently-computed sun directions drifting apart
 * would look wrong (shadows pointing one way, sky glow pointing another).
 */
export function sunDirectionFromAzimuthElevation(
  azimuthDeg: number,
  elevationDeg: number,
): THREE.Vector3 {
  const azimuthRad = THREE.MathUtils.degToRad(azimuthDeg);
  const elevationRad = THREE.MathUtils.degToRad(elevationDeg);

  const x = Math.cos(elevationRad) * Math.sin(azimuthRad);
  const y = Math.sin(elevationRad);
  const z = Math.cos(elevationRad) * Math.cos(azimuthRad);

  return new THREE.Vector3(x, y, z);
}
